import * as React from "react";
import "../../css/pages/footer.scss";
import PhoneEnabledIcon from "@mui/icons-material/PhoneEnabled";
import EmailIcon from "@mui/icons-material/Email";
import FaxIcon from "@mui/icons-material/Fax";
import InstagramIcon from "@mui/icons-material/Instagram";
import { NavLink } from "react-router-dom";
interface Props {}
const Footer: React.FC<Props> = (Props) => {
  return (
    <footer className="footer">
      <div className="footerContainer">
        <div className="footerLeftSide">
          <div className="subFooterTitle">تماس با ما</div>
          <div className="leftSideItems">
            <PhoneEnabledIcon />
            <div>01734346637 :</div>
          </div>
          <div className="leftSideItems">
            <EmailIcon />
            <div>SaaePRC@gmail.com :</div>
          </div>
          <div className="leftSideItems">
            <FaxIcon />
            <div>01734346637 :</div>
          </div>
          <div className="footerSocialmediacontainer">
            <div className="instagram">
              <a
                href="https://www.instagram.com/markazsaee/"
                target="_blank"
                aria-label="Instagram page of مرکز ساعی"
                rel="noopener noreferrer"
              >
                <InstagramIcon fontSize="large" name="Instagram" />
              </a>
            </div>
          </div>
        </div>
        <div className="footerMiddleSide">
          <div className="subFooterTitle">محتوای سایت</div>
          <ul>
            <li>
              <NavLink to="/">خانه</NavLink>
            </li>

            <li>
              <NavLink to="/expertise">حیطه های فعالیت</NavLink>
            </li>
            <li>
              <NavLink to="/contactus">تماس با ما</NavLink>
            </li>
            <li>
              <NavLink to="/admin/adminpanel">پنل ادمین</NavLink>
            </li>
          </ul>
        </div>
        <div className="footerRightSide">
          <div className="subFooterTitle">درباره ما</div>
          مرکز روزانه توانبخشی جسمی_حرکتی ساعی در سال 1393 در شهرستان کردکوی
          استان گلستان تاسیس گردیده است.خدمات مرکز شامل فیزیوتراپی، کاردرمانی ،
          گفتاردرمانی، روانشناسی، آموزشی و امور هنری می باشد
        </div>
      </div>
    </footer>
  );
};
export default Footer;
